"use client"

import { ReactNode } from "react"

type Props = {
  children: ReactNode
  className?: string
}

export default function TextBoldM({
  children,
  className = "",
}: Props) {
  return (
    <p
      className={`
        text-sm
        font-bold
        leading-4
        normal-case
        tracking-normal
        ${className}
      `}
    >
      {children}
    </p>
  )
}